import { createApiCall, MethodType, URI } from "../Api";
import { LoginData } from "models/authentication";
import { ChangePasswordData } from "models/changePassword";

export const fetchLogin = (payload: LoginData) => {
  return createApiCall(MethodType.POST, URI.AUTH.LOGIN, {
    user: payload,
  });
};

export const requestChangePassword = (payload: ChangePasswordData) => {
  return createApiCall(MethodType.PUT, URI.AUTH.CHANGE_PASSWORD, {
    user: payload,
  });
};
